import React from 'react'

function Design() {
    return (
        <div className="flex pos_relative height--100">
            <div className="content_left bg_gray padding--10">
                <div className="video-sm bg_black border_radius flex margin_bottom--10">
                    <video></video>
                </div>
                <div className="content_left__filmstrip">
                    <div className="flex margin_bottom--10">
                        <select className="form_control width--100">
                            <option>Select</option>
                            <option>Select</option>
                            <option>Select</option>
                        </select>
                        <button href="javascript:void(0);" className="margin_left--10">
                            <svg width="16" viewBox="5 5 14 14"><path fill="#666971" d="M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z"></path></svg>
                        </button>
                        <button href="javascript:void(0);" className="margin_left--10">
                            <svg width="18" viewBox="2 4 20 16"><path fill="#666971" d="M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 2v.511l-8 6.223-8-6.222V6h16zM4 18V9.044l7.386 5.745a.994.994 0 0 0 1.228 0L20 9.044 20.002 18H4z"></path></svg>
                        </button>
                    </div>
                    <div className="content_left__filmstrip__video bg_white border_radius flex flex__column padding--10 margin_bottom--10">
                        <div className="video-sm bg_black border_radius margin_bottom--10">
                            <video></video>
                        </div>
                        <div className="video-sm bg_black border_radius margin_bottom--10">
                            <video></video>
                        </div>
                        <div className="video-sm bg_black border_radius">
                            <video></video>
                        </div>
                    </div>
                </div>
            </div>
            <div className="content_right bg_white flex">
                <div className="content_right__tools bg_white border-right flex flex__column flex__vcenter height--100 padding--10">
                    <button href="javascript:void(0);" className="margin_bottom--10">
                        <svg width="27" viewBox="2 2 20 18"><path fill="#666971" d="M12 8c-2.168 0-4 1.832-4 4s1.832 4 4 4 4-1.832 4-4-1.832-4-4-4zm0 6c-1.065 0-2-.935-2-2s.935-2 2-2 2 .935 2 2-.935 2-2 2z"></path><path fill="#666971" d="M20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.996.996 0 0 0-.707.293L6.586 5H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 18V7h3c.266 0 .52-.105.707-.293L10.414 4h3.172l2.707 2.707A.996.996 0 0 0 17 7h3l.002 11H4z"></path></svg>
                    </button>
                </div>
                <div className="content_right__video bg_black border_radius flex padding--10 margin--10">
                    <video></video>
                    <div className="content_right__video__actions flex flex__hcenter width--100">
                        <button href="javascript:void(0);" className="btn_red">
                            <svg width="21" className="rotate--135" viewBox="2.99 2 19.01 19.01"><path fill="#ffffff" d="M17.707 12.293a.999.999 0 0 0-1.414 0l-1.594 1.594c-.739-.22-2.118-.72-2.992-1.594s-1.374-2.253-1.594-2.992l1.594-1.594a.999.999 0 0 0 0-1.414l-4-4a.999.999 0 0 0-1.414 0L3.581 5.005c-.38.38-.594.902-.586 1.435.023 1.424.4 6.37 4.298 10.268s8.844 4.274 10.269 4.298h.028c.528 0 1.027-.208 1.405-.586l2.712-2.712a.999.999 0 0 0 0-1.414l-4-4.001zm-.127 6.712c-1.248-.021-5.518-.356-8.873-3.712-3.366-3.366-3.692-7.651-3.712-8.874L7 4.414 9.586 7 8.293 8.293a1 1 0 0 0-.272.912c.024.115.611 2.842 2.271 4.502s4.387 2.247 4.502 2.271a.991.991 0 0 0 .912-.271L17 14.414 19.586 17l-2.006 2.005z"></path></svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Design